import { CART_PRODUCT_MODEL_KEY } from 'models/daos/cart-product/constants'
import { CART_PRODUCTS_DOMAIN } from 'modules/cart-products/constants'
import { PRODUCTS_PATH } from 'modules/products/constants'
import { getInstancesDomainSelector } from 'modules/redux/selectors/domain'
import { getDomainMapValueReduxUtil } from 'modules/redux/utils/get-domain-map-value'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import updateReduxUtil from 'modules/redux/utils/update'
import { createSelector } from 'reselect'
import { getObjectUtil } from 'packages/src'

function getCartProductsCartSelector () {
  return createSelector(
    state => getObjectUtil(state, PRODUCTS_PATH.DATA),
    getInstancesDomainSelector(CART_PRODUCTS_DOMAIN),
    (productsDomainMap, cartProducts) => {
      return cartProducts.map(cartProduct => {
        const productPointer = (
          getValueReduxUtil(cartProduct, CART_PRODUCT_MODEL_KEY.PRODUCT)
        )
        const product = (
          productsDomainMap[getDomainMapValueReduxUtil(productPointer)]
        )
        return updateReduxUtil(cartProduct, {
          [CART_PRODUCT_MODEL_KEY.PRODUCT]: product
        })
      })
    }
  )
}

export {
  getCartProductsCartSelector
}
